import { ADD_SERVICE_ITEM_TAB } from "../../framework/tab/tabUtilsConstants";
import moment from "moment";

export const columnDefs = [
  {
    headerName: "Service Item Id",
    field: "productId",
    flex: 1,
    hide: true,
  },
  {
    headerName: "Service Item",
    field: "productName",
    flex: 1,
  },
  {
    headerName: "MRP",
    field: "mrp",
    flex: 1,
  },
  {
    headerName: "HSN Code",
    field: "hsnCode",
    flex: 1,
  },
  {
    headerName: "GST %",
    field: "gst",
    flex: 1,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    flex: 1,
  },
  {
    headerName: "Created Time",
    field: "updatedTime",
    flex: 1,
  }
];

export const columnDefsFunctions = {
  updatedTime : {
      valueFormatter: (params) => {
        return params.value
          ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
          : "";
      },
    },
  }

export const transformPayload = (data) => {
  return {
    productId: data?.productId || undefined,
    productName: data?.productName || "",
    productNameNospace: data?.productName?.split(" ").join("") || "",
    mrp: data?.mrp || "",
    gst: data?.gst?.id || 0,
    hsnCode: data?.hsnCode || "",
    remarks: data?.remarks || "",
  };
};

export const initial_state_service_item = {
  type: ADD_SERVICE_ITEM_TAB,
  label: "Service Item Master",
  allowMultipleTabs: false,
};
